export interface EnderecoCep {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
}

// Aplica a máscara de CEP enquanto a pessoa digita (00000-000).
export function mascaraCEP(v: string): string {
  const d = v.replace(/\D/g, '').slice(0, 8);
  if (d.length <= 5) return d;
  return `${d.slice(0, 5)}-${d.slice(5)}`;
}

// Busca o endereço pelo CEP na ViaCEP. Retorna null quando o CEP
// não está completo ou não foi encontrado.
export async function buscarEnderecoPorCep(cep: string): Promise<EnderecoCep | null> {
  const digitos = cep.replace(/\D/g, '');
  if (digitos.length !== 8) return null;
  try {
    const res = await fetch(`https://viacep.com.br/ws/${digitos}/json/`);
    if (!res.ok) return null;
    const data = (await res.json()) as EnderecoCep & { erro?: boolean };
    if (data.erro) return null;
    return data;
  } catch {
    return null;
  }
}